import React, { useContext } from 'react'
import { ListItemText, MenuItem, Select } from '@mui/material'

//Internal Imports
import { LanguageContext } from 'context/LanguageContext'
import langDropDownTheme from './languageSelectorTheme'
import constants from 'utils/constants'
import { useDispatch } from 'react-redux'
import { refreshApp } from 'modules/authentication/actions'

const LanguageSelector = () => {
    const { language, languages, updateLanguage } = useContext(LanguageContext)
    const routes = location.pathname.split('/')
    const capitalize = (str, lower = false) =>
    (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["([{])+\S/g, match => match.toUpperCase())
    const reverseTransform = item => capitalize(item.replace(/-/g, ' '))

    const categoryRoute = reverseTransform(routes[routes.length - 1])

    if (languages.length < 2 || constants.isLanguageChangeEnabled === 'false') return null

    const dispatch = useDispatch()
    return (
        <Select
            value={language}
            onChange={obj => {
                const value = obj.target.value
                updateLanguage({ forcedLanguage: value })
                dispatch(refreshApp(categoryRoute))
            }}
            variant="outlined"
            sx={langDropDownTheme}
        >
            {languages.map(({ code }) => (
                <MenuItem key={code} value={code}>
                    <ListItemText primary={code.toUpperCase()} style={{ display: 'flex' }} />
                </MenuItem>
            ))}
        </Select>
    )
}

export default LanguageSelector
